/* eslint-disable multiline-ternary */
/* eslint-disable array-bracket-newline */
export const clientsdb = [
  {
    id: 1,
    clientCode: '123456789',
    codeType: 'dui',
    dteType: '01',
    company: 'Empresa A',
    receiverEmail: 'empresaA@example.com',
    receiverPhoneNumber: '12345678',
    receiverName: 'juan perez',
    endDate: null,
    tradeName: 'Trade Name A',
    EconomicActivity: {
      value: '01111',
      label: 'Cultivo de cereales excepto arroz y para forrajes',
    },
    NIT: '123456789',
    DUI: '123456789',
    NRC: '56789012345678',
    department: { value: '01', label: 'Ahuachapán' },
    municipality: { value: '01', label: 'AHUACHAPÁN' },
    address: 'Address A',
    typeEntity: { label: 'Natural', value: 'N' },
  },
  {
    id: 2,
    clientCode: '67890',
    codeType: 'nit',
    dteType: '02',
    company: 'Empresa B',
    receiverEmail: 'empresaB@example.com',
    receiverPhoneNumber: '12345678',
    receiverName: 'maria lopez',
    endDate: null,
    tradeName: 'Trade Name B',
    EconomicActivity: {
      value: '01111',
      label: 'Cultivo de cereales excepto arroz y para forrajes',
    },
    NIT: '56789012345678',
    DUI: '56789012345678',
    NRC: '90123456789012',
    department: { value: '01', label: 'Ahuachapán' },
    municipality: { value: '01', label: 'AHUACHAPÁN' },
    address: 'Address B',
    typeEntity: { label: 'Jurídica', value: 'J' },
  },
  // Add more users as needed
]

export let productServicedb = [
  // {
  //   id: 3.5,
  //   prodType:{ value: 'Producto', label: 'Producto' },
  //   productCode: '0003',
  //   productName: 'Monitor',
  //   quantity: 20,
  //   description: "new",
  //   unitOfMeasure: { value: 'Metro', label: 'Metro' },
  //   TypeOfSale: 'Bienes',
  //   price: 300,
  //   discount: 50,
  //   accept: true,
  //   isActive: true
  // }
]

export const registerLocalData = (products) => {
  productServicedb = products

  return productServicedb
}

export const addLocalProduct = (product) => {
  productServicedb.push(product)

  return product
}

export const updateLocalProduct = (product) => {
  // Implementa la lógica para actualizar el usuario en la base de datos ficticia
  // Por ejemplo, puedes reemplazar el usuario en el array `clientsdb`
  const index = productServicedb.findIndex(
    (item) => item.id === product.id
  )
  if (index !== -1) {
    productServicedb[index] = product
  }

  return product
}

export const deleteLocalUser = (id) => {
  const index = productServicedb.findIndex((item) => item.id === id)

  if (index !== -1) {
    productServicedb.splice(index, 1)
  }

  return productServicedb
}
